import { FC } from 'react';

import { getLocalSvgIcon } from '@telialt/common-icon/src/utils';

import { DualMode, HboMaxIconModeDesktop, HboMaxIconModeMobile } from './AdaptiveHboMaxIcon.styles';

export const AdaptiveHboMaxIcon: FC<{ className?: string }> = ({ className }) => {
    const hboMaxLogoSmall = getLocalSvgIcon('hbo-max-logo-small');

    return (
        <DualMode className={className}>
            <HboMaxIconModeDesktop />
            <HboMaxIconModeMobile svg={hboMaxLogoSmall} />
        </DualMode>
    );
};
